import React from 'react';
import TextareaAutosize from 'react-textarea-autosize';
import TransitionBlock from '../TransitionBlock'
import { formatBezierCurveCSS } from '../../utils';
import './multilineBlock.scss';

export default class MultiLineBlock extends React.Component {
  constructor(props) {
    super(props)
		this.state = { lines: [] };	
		this.editTextArea = null;	
	}

	componentDidMount() {
		this.generateLines();
	}

	onKeyDown = (e) => {
		switch(e.key) {
			case 'Escape': 
				this.onAccept();
				break;
			default: 
				return;
		}
	}

	setTextAreaRef = (ref) => {
		this.editTextArea = ref;
	}

	onFocus = () => {
		this.onEdit();
	}

	onBlur = () => {
		this.onAccept();
	}

	onAccept = () => {		
		const {onEditModeChange} = this.props;
		this.generateLines();
		onEditModeChange(false);
	}

	onEdit = () => {
		const {onEditModeChange} = this.props;
		setTimeout(() => {
			if(this.editTextArea) {
				this.editTextArea.focus();
			}
		}, 200)
		onEditModeChange(true);
	}

	generateLines = () => {
		const {copy} = this.props;
		const lines = copy.split('\n');
		this.setState({ lines: lines });
	}

  	render() {
		const {copy, onChange, fontOptions, transitionOptions, inEditMode} = this.props;
		const {lines} = this.state;		
	
		const bezierCurve = formatBezierCurveCSS(transitionOptions.bezierCurve);

		return (
      		<div className="multiline-editor">

				<div className={`multiline-editor__textarea ${inEditMode ? '' : 'hidden'}`}>
					<FontOptionsWrapper {...this.props} >
						<TextareaAutosize
							inputRef={ref => this.setTextAreaRef(ref)}
							value={copy}
							placeholder="Enter your wittiest copy."
							onChange={onChange}
							onKeyDown={this.onKeyDown}
							onFocus={this.onFocus}
							onBlur={this.onBlur}
						/>
					</FontOptionsWrapper>
				</div>

				{!inEditMode && <div className={`multiline-view__wrapper`}>
					{lines.map((line, i) => {
						return (
							<FontOptionsWrapper key={i} {...this.props} onClick={this.onEdit}>
								<TransitionBlock 	
									{...transitionOptions}
									triggerOnce
									from={transitionOptions.direction}
									delay={i * transitionOptions.multilineOffsetDelay}
									animateOpacity={transitionOptions.opacity}
									duration={transitionOptions.duration}
									offset={`${transitionOptions.offset}px`}
									transition={bezierCurve}
									underline={fontOptions.underline}
								>
									{line}
								</TransitionBlock>
						</FontOptionsWrapper>);
					})}					
				</div>
				}
      
    	  </div>
    	)
  	}
}

class FontOptionsWrapper extends React.PureComponent {
	render() {
		const {transitionOptions, fontOptions, onClick, staticView} = this.props;
		
		return <div	onClick={onClick}	
			style={{
				fontFamily: fontOptions.customFont ? `'${fontOptions.customFont}'` : fontOptions.family,
				fontWeight: fontOptions.fontWeight,
				fontSize: `${fontOptions.size}px`,
				color: staticView ? 'white' : fontOptions.color,
				lineHeight: `${fontOptions.lineHeight}px`,
				letterSpacing: `${fontOptions.letterSpacing}em`,
				maxWidth: `${fontOptions.maxWidth}px`,
				width: `${fontOptions.maxWidth}px`,
				overflow: `${transitionOptions.multilineMasking ? 'hidden' : 'visible'}`,
				pointerEvents: staticView ? 'none' : 'normal'
			}}
		>
			{this.props.children}
		</div>
	}
};
